export function sortByOccurence (array)  {
  return (
    array
      .filter((e) => e)
      .sort((a, b) => a !== undefined && b !== undefined
        && parseFloat(a?.badgeCount ? a.badgeCount : 0) - parseFloat(b?.badgeCount ? b.badgeCount : 0))
      .reverse());
}
